import { createContext, useContext, useEffect, useState } from "react";

// Create context
const ApplicationModeContext = createContext();

// Provider component
export const ApplicationModeProvider = ({ children }) => {
  // Load from localStorage (default to "live" if not set)
  const [isTestMode, setIsTestMode] = useState(() => {
    return localStorage.getItem("testMode") === "true"; // Ensure boolean value
  });

  // Save mode to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("testMode", isTestMode);
  }, [isTestMode]);

  // Convert boolean to "test" or "live"
  const applicationMode = isTestMode ? "test" : "live";

  return (
    <ApplicationModeContext.Provider value={{ applicationMode, setIsTestMode, isTestMode }}>
      {children}
    </ApplicationModeContext.Provider>
  );
};

// Custom hook to use context
export const useApplicationMode = () => {
  return useContext(ApplicationModeContext);
};
